import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const footerCategories = categories.slice(0, 4);

const footerColumns = [
  {
    title: '内容分类',
    links: [
      ...footerCategories.map((c) => ({ name: c.name, path: `/category/${c.slug}` })),
      { name: '全部内容', path: '/category/exclusive' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '用户口碑', path: '/about#testimonials' },
      { name: '联系我们', path: '/about#contact' },
      { name: '常见问题', path: '/#faq' },
    ],
  },
  {
    title: '热门推荐',
    links: [
      { name: '最新推荐', path: '/category/latest' },
      { name: '热门排行', path: '/category/trending' },
      { name: '深度解读', path: '/category/deep-dive' },
      { name: '独家精品', path: '/category/exclusive' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/90">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-5 mb-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
                爱情岛独家
              </span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed">
              最权威、最私密的独家内容体验平台。汇聚海量精选资源，为您带来与众不同的专属享受。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors" aria-label="邮箱" rel="nofollow">
                <i className="ri-mail-line text-base"></i>
              </a>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href={col.links[0]?.path || '#'}>{col.title}</a>
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 爱情岛独家 版权所有 | 京ICP备2026080501号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}